import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const listInterviews = async (params = {}) => {
  const { data } = await api.get("/interviews", { params });
  return data;
};

export const getInterview = async (id) => {
  const { data } = await api.get(`/interviews/${id}`);
  return data;
};

export const getRelated = async (id) => {
  const { data } = await api.get(`/interviews/${id}/related`);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};

export const createSubmission = async (payload) => {
  const { data } = await api.post("/submissions", payload);
  return data;
};

export const adminSubmissions = async (kind = "all") => {
  const { data } = await api.get("/admin/submissions", { params: { kind } });
  return data;
};

export const adminDeleteSubmission = async (id) => {
  const { data } = await api.delete(`/admin/submissions/${id}`);
  return data;
};

export const adminNewsletter = async () => {
  const { data } = await api.get("/admin/newsletter");
  return data;
};

export const getStats = async () => {
  const { data } = await api.get("/stats");
  return data;
};

export const getCategories = async () => {
  const { data } = await api.get("/categories");
  return data.categories;
};

// Admin
export const adminListInterviews = async () => (await api.get("/admin/interviews")).data;
export const createInterview = async (payload) => (await api.post("/interviews", payload)).data;
export const updateInterview = async (id, payload) => (await api.put(`/interviews/${id}`, payload)).data;
export const deleteInterview = async (id) => (await api.delete(`/interviews/${id}`)).data;

// Auth
export const authMe = async () => (await api.get("/auth/me")).data;
export const authSession = async (sessionId) =>
  (await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } })).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;
